import { render, staticRenderFns } from "./BusinessHoursDay.vue?vue&type=template&id=04dfa1c1&scoped=true"
import script from "./BusinessHoursDay.vue?vue&type=script&lang=js"
export * from "./BusinessHoursDay.vue?vue&type=script&lang=js"
import style0 from "./BusinessHoursDay.vue?vue&type=style&index=0&id=04dfa1c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfa1c1",
  null
  
)

export default component.exports